import { FeatureFlag } from '@web/common';
import { isFeatureEnabled } from './isFeatureEnabled';

export function getFeature<T>(flag: FeatureFlag, feature: T): null | T {
  return isFeatureEnabled(flag) ? feature : null;
}
